import { render } from "./SaveWorkShift.vue?vue&type=template&id=b93f1440&scoped=true"
import script from "./SaveWorkShift.vue?vue&type=script&lang=js"
export * from "./SaveWorkShift.vue?vue&type=script&lang=js"

import "./work-shift.scss?vue&type=style&index=0&id=b93f1440&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93f1440"]])

export default __exports__